// extracted by mini-css-extract-plugin
module.exports = {"grey":"#C7C9C8","greyDark":"#757575","greyLight":"#F4F4F4","red":"#FE3D5F","medium":"500"};